<div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Subscribers</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">Super Admin</li>
          <li class="breadcrumb-item active" aria-current="page">Subscribers</li>
        </ol>
      </nav>
    </div>
    <!--<div class="ms-2">
      <button class="btn btn-primary d-flex align-items-center" (click)="openModal(addPlanModal)">
        <i class="ti ti-circle-plus me-2"></i>Add New Subscriber
      </button>
    </div>-->
  </div>
  <!-- /Breadcrumb -->
  <div class="row">
    <!-- Total Subscribers -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Total Subscribers</p>
              <h4>{{ analytics.totalSubscriptions | number: '2.0-0' }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-primary flex-shrink-0">
              <i class="ti ti-box fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Total Subscribers -->

    <!-- Active Subscribers -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Active Subscribers</p>
              <h4>{{ analytics.activeSubscriptions | number: '2.0-0' }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-success flex-shrink-0">
              <i class="ti ti-activity-heartbeat fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Active Subscribers -->

    <!-- Inactive Subscribers -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">Inactive Subscribers</p>
              <h4>{{ analytics.inactiveSubscriptions | number: '2.0-0' }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-danger flex-shrink-0">
              <i class="ti ti-player-pause fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /Inactive Subscribers -->

    <!-- No of Subscribers  -->
    <div class="col-lg-3 col-md-6 d-flex">
      <div class="card flex-fill">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center overflow-hidden">
            <div>
              <p class="fs-12 fw-medium mb-1 text-truncate">No of Trials</p>
              <h4>{{ analytics.trialSubscriptions | number: '2.0-0' }}</h4>
            </div>
          </div>
          <div>
            <span class="avatar avatar-lg bg-skyblue flex-shrink-0">
              <i class="ti ti-mask fs-16"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- /No of Subscribers -->
  </div>

  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
      <h5>Subscribers List</h5>
      <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
        <!--<div class="me-3">
          <div class="input-icon-end position-relative">
            <input
              type="text"
              class="form-control date-range bookingrange"
              placeholder="dd/mm/yyyy - dd/mm/yyyy"
            />
            <span class="input-icon-addon">
              <i class="ti ti-chevron-down"></i>
            </span>
          </div>
        </div>-->
        <div class="me-3">
          <select
            data-extension-safe
            class="form-select form-select-sm col-md-1"
            id="entries"
            [(ngModel)]="pageLimit"
            (change)="onPageLimitChange()"
          >
            <!-- <option selected disabled>Show Entries Per Page</option> -->
            <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
          </select>
        </div>
        <div class="dropdown me-3">
          <select
            class="form-select"
            id="selectedPlanType"
            [(ngModel)]="selectedPlanType"
            (ngModelChange)="onFilterChange(true)"
          >
            <option selected [ngValue]="null">Select Type</option>
            <option value="monthly">Monthly</option>
            <option value="yearly">Yearly</option>
          </select>
        </div>
        <div class="dropdown me-3">
          <select
            class="form-select"
            id="selectedPlanStatus"
            [(ngModel)]="selectedSubscriptionStatus"
            (ngModelChange)="onFilterChange(true)"
          >
            <option selected [ngValue]="null">Select Status</option>
            <option *ngFor="let v of subscriptionStatusValues" [ngValue]="v">
              {{ v | capitalize }}
            </option>
          </select>
        </div>
        <div class="dropdown">
          <input
            appTrimInput
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            class="form-control"
            placeholder="Search Subscribers"
          />
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="custom-datatable-filter table-responsive">
        <table class="table datatable">
          <thead class="thead-light">
            <tr>
              <th>Subscription ID</th>
              <th>Business Entity</th>
              <th>Plan</th>
              <th>Billing Cycle</th>
              <th>Total Licences</th>
              <th>Amount</th>
              <th>Next Billing Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sub of subscriptions">
              <td>
                <a (click)="routeToLicenceHistory(sub.subscriptionDisplayId)">{{
                  sub.subscriptionDisplayId
                }}</a>
              </td>
              <td>
                <a href="#">{{ sub.business?.businessName }}</a>
              </td>
              <td>{{ sub.planName }}</td>
              <td>{{ sub.planType | capitalize }}</td>
              <td>
                {{ sub?.licences?.[0]?.totalLicences }}
              </td>
              <td>
                {{
                  sub?.licences?.[0]?.amount | currency: sub.planCurrencySymbol : 'symbol' : '1.2-2'
                }}
              </td>
              <td>{{ sub?.licences?.[0]?.nextBillingDate | date: 'mediumDate' }}</td>
              <td>
                <ng-container [ngSwitch]="sub.subscriptionStatus">
                  <!-- Active -->
                  <span
                    *ngSwitchCase="subscriptionStatus.Active"
                    class="badge bg-success d-inline-flex align-items-center badge-sm"
                  >
                    <i class="ti ti-point-filled me-1"></i>Active
                  </span>

                  <!-- Trialing -->
                  <span
                    *ngSwitchCase="subscriptionStatus.Trialing"
                    class="badge bg-primary d-inline-flex align-items-center badge-sm"
                  >
                    <i class="ti ti-point-filled me-1"></i>Trial
                  </span>

                  <!-- Expired -->
                  <span
                    *ngSwitchCase="subscriptionStatus.Expired"
                    class="badge bg-danger d-inline-flex align-items-center badge-sm"
                  >
                    <i class="ti ti-point-filled me-1"></i>Expired
                  </span>

                  <!-- Past Due -->
                  <span
                    *ngSwitchCase="subscriptionStatus.PastDue"
                    class="badge bg-warning d-inline-flex align-items-center badge-sm"
                  >
                    <i class="ti ti-point-filled me-1"></i>Past Due
                  </span>

                  <!-- Cancelled -->
                  <span
                    *ngSwitchCase="subscriptionStatus.Cancelled"
                    class="badge bg-secondary d-inline-flex align-items-center badge-sm"
                  >
                    <i class="ti ti-point-filled me-1"></i>Cancelled
                  </span>
                  <!-- Upgraded -->
                  <span
                    *ngSwitchCase="subscriptionStatus.Upgraded"
                    class="badge bg-light text-dark d-inline-flex align-items-center badge-sm"
                  >
                    <i class="ti ti-point-filled me-1"></i>Upgraded
                  </span>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex align-items-center justify-content-between ms-2">
        <div>
          <!-- Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
    {{ totalCount }} entries Showing -->
          Showing
          {{ (currentPage - 1) * pageLimit + 1 }}
          to
          {{ Math.min(currentPage * pageLimit, totalCount) }}
          of
          {{ totalCount }} entries
        </div>
        <div class="has-text-centered mt-3">
          <app-pagination
            [currentPage]="currentPage"
            [pageSize]="pageLimit"
            [totalRows]="totalCount"
            (pageChange)="onPageChange($event)"
          >
          </app-pagination>
        </div>
      </div>
      <!-- <div class="p-3 d-flex justify-content-end" *ngIf="totalItems > 0">
        <app-pagination
          [currentPage]="currentPage"
          [pageSize]="limit"
          [totalRows]="totalItems"
          (pageChange)="onPageChange($event)"
        >
      </app-pagination>
      </div> -->
    </div>
  </div>
</div>

<!-- Add Subscribers -->
<ng-template #addPlanModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ operation }} Subscribers</h4>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close">
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="name" class="form-label"
              >Subscriber Name<span class="text-danger"> *</span></label
            >
            <input type="text" id="name" class="form-control" formControlName="name" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="type" class="form-label"
              >Plan Type<span class="text-danger"> *</span></label
            >
            <select id="type" class="form-select" formControlName="type">
              <option>Select</option>
              <option [value]="'monthly'">Monthly</option>
              <option [value]="'yearly'">Yearly</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="position" class="form-label"
              >Plan Position<span class="text-danger"> *</span></label
            >
            <select id="position" class="form-select" formControlName="position">
              <option [ngValue]="null" disabled>Select available position</option>
              <option *ngFor="let pos of availablePositions" [ngValue]="pos">{{ pos }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="maxUsers" class="form-label"
              >Minimum Users<span class="text-danger"> *</span></label
            >
            <input
              appTrimInput
              id="maxUsers"
              type="number"
              class="form-control"
              formControlName="minimumLicences"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="price" class="form-label"
              >Price Per User<span class="text-danger"> *</span></label
            >
            <div class="pass-group">
              <input
                appTrimInput
                id="price"
                type="number"
                class="form-control"
                formControlName="price"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="currencyId" class="form-label"
              >Currency<span class="text-danger"> *</span></label
            >
            <div class="pass-group">
              <select class="form-select" id="currencyId" formControlName="currencyId">
                <option selected value="">Select Currency</option>
                <option *ngFor="let country of countries$ | async" [ngValue]="country.id">
                  {{ country.currency_name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="discountType" class="form-label"
              >Discount Type<span class="text-danger"> *</span></label
            >
            <div class="pass-group">
              <select id="discountType" class="form-select" formControlName="discountType">
                <option>Select</option>
                <option [value]="'fixed'">Fixed</option>
                <option [value]="'percentage'">Percentage</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="discountValue" class="form-label"
              >Discount<span class="text-danger"> *</span></label
            >
            <div class="pass-group">
              <input
                appTrimInput
                id="discountValue"
                type="number"
                class="form-control"
                formControlName="discountValue"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6>Available Features</h6>
            <div class="form-check d-flex align-items-center">
              <!--<label class="form-check-label mt-0 text-dark fw-medium">
                      <input class="form-check-input" type="checkbox" />
                      Select All
                    </label>-->
            </div>
          </div>
        </div>
        <div class="row" formArrayName="availableFeatures">
          <div class="col-lg-3 col-sm-6" *ngFor="let feature of allPossibleFeatures; let i = index">
            <div class="form-check d-flex align-items-center mb-3">
              <label class="form-check-label mt-0 text-dark fw-medium">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  [formControlName]="i"
                />
                {{ feature.name }}
              </label>
            </div>
          </div>
        </div>
        <div class="row align-items-center gx-3">
          <div class="col-md-4">
            <div class="d-flex align-items-center mb-3">
              <div class="flex-fill">
                <label for="trialDays" class="form-label"
                  >Trial Days<span class="text-danger"> *</span></label
                >
                <input
                  appTrimInput
                  id="trialDays"
                  type="number"
                  class="form-control"
                  formControlName="trialDays"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="d-block align-items-center ms-3">
              <label for="isRecommended" class="form-check-label mt-0 me-2 text-dark">
                Is Recommended
              </label>
              <div class="form-check form-switch me-2">
                <input
                  appTrimInput
                  id="isRecommended"
                  class="form-check-input me-2"
                  type="checkbox"
                  role="switch"
                  formControlName="isRecommended"
                />
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="mb-3">
              <label for="isActive" class="form-label"
                >Status<span class="text-danger"> *</span></label
              >
              <select id="isActive" class="form-select" formControlName="isActive">
                <option>Select</option>
                <option [ngValue]="true">Active</option>
                <option [ngValue]="false">Inactive</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="description" class="form-label"
              >Description
              <i
                class="ti ti-info-circle text-info"
                ngbTooltip="Use [+] for a success mark (✅),
                        [-] for a failure mark (❌).
                        Any other line will be treated as neutral information."
                placement="right"
              ></i
            ></label>
            <textarea
              id="description"
              class="form-control"
              formControlName="description"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
        {{ operation === 'Add' ? 'Add Plan' : 'Save Changes' }}
      </button>
    </div>
  </form>
</ng-template>
<!-- /Add Subscriber -->

<!-- Delete Modal -->
<!--<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">Ar you sure you want to delete the Subscriber?</p>
    <div class="d-flex justify-content-center">
      <a href="javascript:void(0);" class="btn btn-light me-3" (click)="closeModal()">Cancel</a>
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Delete</a>
    </div>
  </div>
</ng-template>-->
<!-- /Delete Modal -->
